import { defineMessages } from 'react-intl'

export default defineMessages({
  cancelButton: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  changeSpaceHelp: {
    id: 'OrganizationSettings.Overview.DefaultSpaceChangeDescription',
    defaultMessage:
      'Please remember that changing the default space for an organization sets the default space for newly provisioned users but does not add existing users to this space.'
  },
  companyCode: {
    id: 'OrganizationSettings.Overview.CompanyCode',
    defaultMessage: 'Company Code'
  },
  defaultSpace: {
    id: 'OrganizationSettings.Overview.DefaultSpace',
    defaultMessage: 'Default Space'
  },
  edit: {
    id: 'Edit',
    defaultMessage: 'Edit'
  },
  invalidImage: {
    id: 'FormError.invalidImageWithSVG',
    defaultMessage: 'Please enter a valid image URL. Valid image types are gif, jpg, jpeg, png, and svg.'
  },
  invalidUrl: {
    id: 'FormError.InvalidURL',
    defaultMessage: 'Please enter a valid URL.'
  },
  logo: {
    id: 'OrganizationSettings.Overview.Logo',
    defaultMessage: 'Logo'
  },
  none: {
    id: 'None',
    defaultMessage: 'None'
  },
  organizationName: {
    id: 'OrganizationSettings.Overview.Name',
    defaultMessage: 'Organization Name'
  },
  organizationId: {
    id: 'OrganizationSettings.Overview.Id',
    defaultMessage: 'Organization Id'
  },
  supportUrl: {
    id: 'OrganizationSettings.Overview.SupportUrl',
    defaultMessage: 'Support Url'
  },
  overview: {
    id: 'OrganizationSettings.Overview',
    defaultMessage: 'Organization Overview'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  saveButton: {
    id: 'Save',
    defaultMessage: 'Save'
  },
  saving: {
    id: 'Saving',
    defaultMessage: 'Saving...'
  },
  spaceId: {
    id: 'OrganizationSettings.Overview.SpaceId',
    defaultMessage: '{name} (id: {id})'
  },
  title: {
    id: 'OrganizationSettingsPage.Title',
    defaultMessage: 'Organization Settings'
  }
})
